import React from "react";
import { Button, Routes } from "@mui/material";
import axios from "axios";
import ResourcesItem from "./ResourcesItem";

const ResourcesList = ({ allResources, getAllResources, urls }) => {
  function downloadPDF(url) {
    const pdfUrl = "https://www.clickdimensions.com/links/TestPDFfile.pdf";

    // const fileName = "dummy-file.pdf";

    // Create a temporary anchor element
    const link = document.createElement("a");
    link.href = url;
    // link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const deleteResource = async (id) => {
    try {
      const response = await axios.delete(
        `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/resources/delete-resource/${id}`
      );
      console.log(response);
      getAllResources();
    } catch (err) {
      console.error(err);
      alert("Some error occured. Please try again.");
    }
  };

  return (
    <>
      <div style={{ height: "100%", overflowY: "auto" }}>
        {/* <h3 style={{marginLeft:"20%",fontColor:"black"}}>  Amount Earned-</h3> */}

        {/* <h1>hare krsna</h1> */}
        <section class="ftco-section">
          <div class="container" style={{ maxWidth: "100%" }}>
            <div class="row justify-content-center">
              {/* <div class="col-md-6 text-center mb-5">
              <h2 class="heading-section">Table #09</h2>
            </div> */}
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table-wrap" style={{ height: "30rem" }}>
                  <table
                    class="table table-striped"
                    style={{ textAlign: "center" }}
                  >
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>View </th>
                        <th>Status</th>

                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allResources?.map((each) => (
                        <ResourcesItem
                          eachItem={each}
                          downloadPDF={downloadPDF}
                          deleteResource={deleteResource}
                          getAllResources={getAllResources}
                        />
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ResourcesList;
